import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "../Components/Nav";
import { auth, db } from "../config";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import Footer from "../Components/Footer";

function ReferralHistory() {
  const [user, setUser] = useState(null);
  const [referrals, setReferrals] = useState([]);
  const [userData, setUserData] = useState({ myReferralId: "", referreduserid: "nnnnn", fullname: "Unknown" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          // Fetch user data
          const userDocRef = doc(db, "users", currentUser.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            setUserData({
              myReferralId: userDoc.data().myReferralId || "",
              referreduserid: userDoc.data().referreduserid || "nnnnn",
              fullname: userDoc.data().fullname || "Unknown",
            });
          } else {
            setError("User data not found.");
          }

          // Fetch referrals
          const referralsQuery = query(
            collection(db, "referrals"),
            where("referrerId", "==", currentUser.uid)
          );
          const referralsSnapshot = await getDocs(referralsQuery);
          const referralsData = referralsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setReferrals(referralsData);
        } catch (err) {
          console.error("Error fetching data:", err);
          setError("Failed to load referral data: " + err.message);
        } finally {
          setLoading(false);
        }
      } else {
        setUser(null);
        navigate("/auth/login");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // Copy referral link to clipboard
  const copyToClipboard = () => {
    const referralLink = `https://apexyeild.com/register.html.html?referralid=${userData.myReferralId}`;
    navigator.clipboard.writeText(referralLink).then(() => {
      alert("Referral link copied to clipboard!");
    }).catch((err) => {
      console.error("Failed to copy:", err);
      alert("Failed to copy referral link.");
    });
  };

  return (
    <div>
      <style>
        {`
          .custom-select {
            display: inline-block;
            max-width: 100%;
            height: calc(2.25rem + 2px);
            padding: .375rem 1.75rem .375rem .75rem;
            line-height: 1.5;
            color: #0b57e3;
            vertical-align: middle;
            background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center;
            background-size: 8px 10px;
            border: 4px solid black;
            border-radius: .25rem;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
          .custom-select:focus {
            border-color: #80bdff;
            outline: 0;
          }
          .custom-select:disabled {
            color: #868e96;
            background-color: #e9ecef;
          }
          .footer-block {
            min-height: 400px;
            padding: 50px 0;
            background: linear-gradient(to right, #212529, #131516), url(../img/project4.jpg);
          }
          .foot-header {
            font-family: "Montserrat", Sans-serif;
            font-weight: 600;
            font-size: 1rem;
            margin-bottom: 25px;
            color: #4A4A4A;
          }
          .foot {
            display: block;
            font-size: small;
            margin-bottom: 8px;
            font-family: "Montserrat", Sans-serif;
            color: #A1A39E !important;
          }
          .foot:hover {
            text-decoration: none !important;
            color: #FE413C !important;
          }
          .foot::before {
            content: "-";
            margin-right: 3px;
            color: #FE413C;
          }
          .footer-credit {
            font-family: "Montserrat", Sans-serif;
            color: #FE413C;
            font-size: small;
          }
          .footer-block .small-image {
            width: 250px;
            height: auto;
          }
          .error {
            color: red;
            margin-bottom: 15px;
          }
          .table th, .table td {
            vertical-align: middle;
          }
        `}
      </style>

      <div className="wrapper">
        <Nav />
        <div className="main-panel bg-light">
          <div className="content bg-light">
            <div className="page-inner">
              <div className="mt-2 mb-4">
                <h1 className="title1 text-dark">
                  Refer users to APEXYEILD community
                </h1>
              </div>
              {error && <div className="error">{error}</div>}
              <div className="row">
                <div className="col-md-12 text-center card bg-light shadow-lg p-3 text-dark">
                  <div className="p-4 row">
                    <div className="col-md-8 offset-md-2">
                      <strong>You can refer users by sharing your referral link:</strong>
                      <br />
                      <div className="mb-3 input-group">
                        <input
                          type="text"
                          className="form-control myInput readonly text-dark bg-light"
                          value={`https://apexyeild.com/register.html.html?referralid=${userData.myReferralId}`}
                          id="myInput"
                          readOnly
                          aria-label="Referral Link"
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-outline-secondary"
                            onClick={copyToClipboard}
                            type="button"
                            id="button-addon2"
                            aria-label="Copy Referral Link"
                          >
                            <i className="fas fa-copy" />
                          </button>
                        </div>
                      </div>
                      <strong>or your Referral ID</strong>
                      <br />
                      <h4 style={{ color: "green" }}>{userData.myReferralId}</h4>
                      <br />
                      <h3 className="title1">
                        <small>You were referred by</small>
                        <br />
                        <i className="fa fa-user fa-2x" />
                        <br />
                        <small>
                          {userData.referreduserid === "nnnnn"
                            ? "None"
                            : userData.referreduserid}
                        </small>
                      </h3>
                    </div>
                    <div className="mt-4 col-md-12">
                      <h2 className="title1 text-dark text-left">Your Referrals</h2>
                      <div className="table-responsive">
                        <table className="table UserTable table-hover text-dark">
                          <thead>
                            <tr>
                              <th>Client name</th>
                              <th>Ref. level</th>
                              <th>Parent</th>
                              <th>Client status</th>
                              <th>Date registered</th>
                            </tr>
                          </thead>
                          <tbody>
                            {referrals.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No referrals found.
                                </td>
                              </tr>
                            ) : (
                              referrals.map((referral) => (
                                <tr key={referral.id}>
                                  <td>{referral.name}</td>
                                  <td>Level 1</td>
                                  <td>{userData.fullname}</td>
                                  <td>Active</td>
                                  <td>
                                    {referral.timestamp
                                      ? referral.timestamp.toDate().toLocaleDateString()
                                      : "N/A"}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<Footer/>
          <div
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              zIndex: 1,
              width: "100%",
            }}
          >
            <div
              style={{
                width: "100%",
                backgroundColor: "#FFFFFF",
                overflow: "hidden",
                boxSizing: "content-box",
                textAlign: "right",
                lineHeight: "14px",
                fontSize: "12px",
                fontFeatureSettings: "normal",
                textSizeAdjust: "100%",
                padding: "0px",
                margin: "0px",
              }}
            >
              <div style={{ height: "40px" }}>
                <iframe
                  src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=light&pref_coin_id=1505&invert_hover="
                  width="100%"
                  height={36}
                  scrolling="auto"
                  marginWidth={0}
                  marginHeight={0}
                  frameBorder={0}
                  border={0}
                  style={{ border: 0, margin: 0, padding: 0 }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferralHistory;